import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationReportingService, ProjectsFacade, decrypt } from '@piqet-angular/data';
import { ICellRendererParams } from 'ag-grid-community';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, finalize } from 'rxjs';

@Component({
  selector: 'piqet-angular-report-config-checkbox',
  templateUrl: './report-config-checkbox.component.html',
  styleUrls: ['./report-config-checkbox.component.css'],
})
export class ReportConfigCheckboxComponent {
  params: any;
  isCurrentPack: any;
  packageScenarioId: any;
  disableCheckbox: boolean = false;
  activatedRoute: any;
  projectReportSettingTypeId: any;
  editReportFormatId: any;

  constructor(
    private projectsService: ProjectsService,
    public route: ActivatedRoute,
    private toaster: ToastrService,
    private projectFacade: ProjectsFacade,
    private customService: CustomService,
    private spinnerService: NgxSpinnerService,
    private organizationReportingService: OrganizationReportingService
  ) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    let value: any = decrypt(
      this.route.snapshot.queryParams['param'] ? this.route.snapshot.queryParams['param'] : ''
    );
    value = value && !value.includes('undefined') ? JSON.parse(value) : '';
    this.packageScenarioId = this.route?.snapshot?.queryParams['packageScenarioId'];
    this.projectReportSettingTypeId = value['id'];
    this.editReportFormatId = value['reportFormatId'];
    this.disableCheckbox = this.params.node?.data?.id == 0 ? true : false;
  }

  updateReportSetting(event: any, data: any) {
    let payload;
    if (data.isMaterialImpact || data.isPackagingInd) {
      payload = {
        id: data?.id,
        packagingMetricsCategoryId: data?.parentId,
        isAccess: event?.target?.checked,
        packagingMetricsId: data?.id,
        projectReportSettingId: Number(this.projectReportSettingTypeId),
        reportScopeId: 9,
        reportFormatType: 9,
      };
    } else {
      payload = {
        id: data?.id,
        reportScopeId: data?.reportScopeId,
        isAccess: event?.target?.checked,
        reportFormatType: this.editReportFormatId,
        projectReportSettingId: Number(this.projectReportSettingTypeId),
      };
    }
    this.customService
      .updateCustomReportSettings(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.organizationReportingService.refreshReportSetting();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  currentPack(event: any) {
    if (!this.params.colDef.cellRendererParams?.isShareReport) {
      this.isCurrentPack = event;
      const payload = {
        id: this.params.node.data.id,
        numberofUnitsByYear: Number(
          this.params.node.data.unit || this.params.node.data.numberofUnitsByYear
        ),
        scnearioId: Number(
          this.params.node.data.packageScenarioId || this.params.node.data.scnearioId
        ),
        year:
          this.params.node.data.configurationYear == 'Select a year'
            ? 0
            : Number(this.params.node.data.configurationYear),
        productGroupId: this.params.node.data.productGroup || this.params.node.data.productGroupId,
        isCurrentPack: event.target.checked,
      };
      const obj = { ...this.params.node.data, isCurrentPack: event.target.checked };
      this.updateOrgYearRow(payload);
      this.projectFacade.updateOrgYearActions(obj, 'edit', null, null, 'checkBox');
    }
  }

  updateOrgYearRow(payload: any) {
    this.projectsService
      .updateConfigYearForScenarioYear(payload)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {})
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }
}
